
import '@douyinfe/semi-foundation/modal/modal.scss';
import { ModalState } from '@douyinfe/semi-foundation/modal/modalFoundation';
import Modal from './Modal';
import　{ ModalReactProps } from './Modal';

export type { ConfirmProps } from './confirm';

export type Directions = 'ltr' | 'rtl';

export type { ModalReactProps, ModalState };

export default Modal;
